var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRankGoldNoRibbon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.817C8.65 2.817 2.816 8.65 2.816 16c0 1.633.35 3.15.817 4.55L20.55 3.633c-1.4-.583-2.917-.816-4.55-.816z",
    fill: "#FBF4CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.55 3.633L3.634 20.55C5.5 25.683 10.284 29.183 16 29.183c7.35 0 13.184-5.95 13.184-13.183 0-5.717-3.5-10.5-8.634-12.367z",
    fill: "#F0D23C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2C8.3 2 2 8.3 2 16s6.3 14 14 14 14-6.3 14-14S23.7 2 16 2zm0 25.667c-6.417 0-11.667-5.25-11.667-11.667S9.583 4.333 16 4.333 27.667 9.583 27.667 16 22.417 27.667 16 27.667z",
    fill: "#99740E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.117 18.1h2.8v1.867c-.584.7-1.634 1.05-2.684 1.05-2.333 0-3.966-2.1-3.966-5.017 0-2.917 1.516-5.017 3.616-5.017 1.4 0 2.567.817 3.267 2.334l2.333-1.4c-1.166-2.334-3.266-3.617-5.6-3.617-3.733 0-6.65 3.383-6.65 7.7 0 4.433 2.917 7.583 6.884 7.583 2.216 0 3.966-.816 5.483-2.333V15.3H16v2.8h.117z",
    fill: "#99740E"
  })));
}

export default SvgIconRankGoldNoRibbon;